import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Sparkles, Dumbbell, Heart, Scissors, Smile, Activity, ArrowRight } from "lucide-react";
const categories = [{
  icon: Heart,
  name: "Massage Therapy",
  slug: "massage_therapy",
  description: "Therapeutic and relaxation massage",
  color: "from-wellness-warm to-wellness-warm-light"
}, {
  icon: Sparkles,
  name: "Spa & Wellness",
  slug: "spa_wellness",
  description: "Relaxation and rejuvenation treatments",
  color: "from-wellness-teal to-wellness-teal-light"
}, {
  icon: Scissors,
  name: "Barber Shop & Grooming",
  slug: "barber_shop_grooming",
  description: "Professional haircuts and grooming",
  color: "from-wellness-sage to-wellness-teal-light"
}, {
  icon: Smile,
  name: "Beauty Salon",
  slug: "beauty_salon",
  description: "Hair, styling, and beauty services",
  color: "from-primary to-wellness-sage"
}, {
  icon: Activity,
  name: "Skin Care & Aesthetics",
  slug: "skin_care_aesthetics",
  description: "Facial treatments and skin care",
  color: "from-wellness-warm to-pink-400"
}, {
  icon: Dumbbell,
  name: "Fitness & Personal Training",
  slug: "fitness_personal_training",
  description: "Personal training and fitness programs",
  color: "from-wellness-teal to-primary"
}, {
  icon: Activity,
  name: "Sports Recovery & Rehabilitation",
  slug: "sports_recovery_rehabilitation",
  description: "Physical therapy and recovery services",
  color: "from-sky-500 to-wellness-teal"
}, {
  icon: Sparkles,
  name: "Nail Spa",
  slug: "nail_spa",
  description: "Manicure, pedicure, and nail art",
  color: "from-pink-400 to-wellness-warm"
}];
export function CategoriesSection() {
  return <section className="py-20 bg-background" aria-labelledby="categories-heading">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 id="categories-heading" className="font-display text-3xl md:text-4xl font-bold text-foreground mb-4">Explore Massage & Wellness Services Worldwide</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">From relaxing spa treatments and massage therapy to beauty and grooming, meditation, fitness training, and holistic health services. Book wellness practitioners online across New York, London, Tokyo, and worldwide.</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {categories.map((category, index) => <Link key={category.name} to={`/browse?category=${category.slug}`} className="group">
              <Card variant="elevated" className="p-6 h-full hover:-translate-y-1 transition-all duration-300 animate-fade-up" style={{
            animationDelay: `${index * 0.1}s`
          }}>
                <div className="flex items-start gap-4">
                  <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${category.color} flex items-center justify-center shadow-wellness-sm group-hover:shadow-wellness-md transition-shadow`}>
                    <category.icon className="w-7 h-7 text-primary-foreground" />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center justify-between mb-2">
                      <h3 className="font-display text-lg font-semibold text-foreground group-hover:text-primary transition-colors">
                        {category.name}
                      </h3>
                      <ArrowRight className="w-5 h-5 text-muted-foreground group-hover:text-primary group-hover:translate-x-1 transition-all" />
                    </div>
                    <p className="text-sm text-muted-foreground">
                      {category.description}
                    </p>
                  </div>
                </div>
              </Card>
            </Link>)}
        </div>
      </div>
    </section>;
}